export const actors = [
  {
    id: "a1",
    name: "林晚舟",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20photograph%20of%20an%20elegant%20young%20chinese%20actress%20with%20long%20dark%20hair%20in%20a%20calm%20confident%20pose%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20soft%20lighting%20with%20warm%20highlights%2C%20high%20detail%20editorial%20headshot&width=600&height=600&seq=actor-01&orientation=squarish",
    gender: "女",
    birthday: "1995-04-12",
    birthplace: "中国 · 杭州",
    height: "168cm",
    tags: ["实力派", "悬疑女王", "高口碑"],
    bio: "毕业于中央戏剧学院表演系，以细腻克制的表演风格著称。早年活跃于话剧舞台，后凭借悬疑剧《长夜将明》中冷静果决的刑警江砚一角被观众熟知，被称为「悬疑剧收视保障」。从业数年间参演多部高口碑剧集，注重角色内在逻辑，擅长诠释复杂而隐忍的女性形象。",
    works: ["m1", "m4", "m8", "m11", "m14"],
  },
  {
    id: "a2",
    name: "苏慕白",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20photograph%20of%20a%20handsome%20young%20chinese%20actor%20with%20short%20neat%20hair%20in%20a%20warm%20gentle%20smile%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20soft%20lighting%20with%20warm%20highlights%2C%20high%20detail%20editorial%20headshot&width=600&height=600&seq=actor-02&orientation=squarish",
    gender: "男",
    birthday: "1994-09-28",
    birthplace: "中国 · 青岛",
    height: "184cm",
    tags: ["治愈系", "都市剧", "温柔"],
    bio: "以都市与爱情题材见长的青年演员，气质温和、表演自然。因主演治愈系剧集《春日暖阳》中失意建筑师程野一角而广受欢迎，随后在《追光者》《暗涌》中挑战不同类型角色，展现出扎实的表演功底与角色塑造力。",
    works: ["m2", "m5", "m9", "m12"],
  },
  {
    id: "a3",
    name: "顾清欢",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20photograph%20of%20a%20striking%20young%20chinese%20actress%20with%20delicate%20features%20and%20a%20thoughtful%20gaze%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20soft%20lighting%20with%20warm%20highlights%2C%20high%20detail%20editorial%20headshot&width=600&height=600&seq=actor-03&orientation=squarish",
    gender: "女",
    birthday: "1996-01-06",
    birthplace: "中国 · 成都",
    height: "170cm",
    tags: ["视效大片", "古灵精怪", "多面手"],
    bio: "兼具灵气与张力的新生代女演员，戏路宽广。既有《山海秘境》中勇敢坚毅的古籍修复师，也有《镜中迷城》里陷入心理漩涡的医生。她偏爱挑战高难度角色，被认为是当下最具可塑性的青年演员之一。",
    works: ["m3", "m6", "m7", "m10"],
  },
  {
    id: "a4",
    name: "陆时衍",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20photograph%20of%20a%20rugged%20young%20chinese%20actor%20with%20sharp%20features%20and%20a%20serious%20expression%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20dramatic%20lighting%20with%20warm%20highlights%2C%20high%20detail%20editorial%20headshot&width=600&height=600&seq=actor-04&orientation=squarish",
    gender: "男",
    birthday: "1991-11-17",
    birthplace: "中国 · 哈尔滨",
    height: "187cm",
    tags: ["硬汉", "谍战", "演技派"],
    bio: "以沉稳内敛的气质和出色的肢体表现力著称。在谍战剧《暗涌》中塑造的隐忍情报员令人印象深刻，也在武侠剧《江湖夜雨》中展现了扎实的动作功底。出道多年，从配角一步步走到主角位置，是业内公认的「戏比人红」的演员。",
    works: ["m1", "m3", "m5", "m10", "m11", "m14"],
  },
  {
    id: "a5",
    name: "江月明",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20photograph%20of%20a%20bright%20cheerful%20young%20chinese%20actress%20with%20a%20warm%20natural%20smile%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20soft%20lighting%20with%20warm%20highlights%2C%20high%20detail%20editorial%20headshot&width=600&height=600&seq=actor-05&orientation=squarish",
    gender: "女",
    birthday: "1998-06-30",
    birthplace: "中国 · 厦门",
    height: "165cm",
    tags: ["青春", "甜宠", "元气"],
    bio: "青春题材的新生代面孔，笑起来有让人安心的感染力。因校园剧《花开半夏》中的转学生夏栀一角被观众喜爱，随后在《春日暖阳》《东京物语集》中尝试更成熟的角色，逐步摆脱「青春脸」的标签。",
    works: ["m2", "m6", "m9", "m13"],
  },
  {
    id: "a6",
    name: "沈知遥",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20studio%20portrait%20photograph%20of%20a%20mature%20thoughtful%20chinese%20actor%20with%20slight%20stubble%20and%20a%20quiet%20expression%2C%20soft%20neutral%20grey%20background%2C%20cinematic%20restrained%20lighting%20with%20warm%20highlights%2C%20high%20detail%20editorial%20headshot&width=600&height=600&seq=actor-06&orientation=squarish",
    gender: "男",
    birthday: "1988-03-05",
    birthplace: "中国 · 西安",
    height: "182cm",
    tags: ["演技派", "文艺", "老戏骨"],
    bio: "常年活跃于现实题材与文艺片的实力派演员，以「几乎没有表演痕迹」的自然风格闻名。代表作包括都市群像剧《都市浮生》、家庭剧《老巷人家》以及文艺电影《蓝色回响》，多次获得表演类奖项提名。",
    works: ["m4", "m7", "m8", "m12", "m13"],
  },
];